<div #commentsWrapper class="comments" *ngIf="trackedItem != null">
  <div class="comments-header">
    <h4>Comments</h4>
  </div>
  <div class="comments-content">
    <div *ngFor="let message of trackedItem?.comments" class="comment-bubble">
      <message-bubble origin="client-task" is_comment="true" [message]="message" [user]="user">
      </message-bubble>
    </div>
  </div>
  <div class="chat-input-wrapper">
    <textarea
      class="form-control chat-input"
      #input
      (keyup.enter)="
        send_comment(trackedItem.messageInput, trackedItem.id, input); (false)
      "
      [(ngModel)]="trackedItem.messageInput"
      rows="1"
      [disabled]="isSendingComment"
      autosize
      placeholder="Type a message.&#10;Shift+Enter adds a line."
    ></textarea>
    <i
      class="feather send"
      (click)="send_comment(trackedItem.messageInput, trackedItem.id, input)"
    ></i>
  </div>
</div>
